import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';

export interface Administrator {
  id: number;
  username: string;
  email: string;
  enabled: boolean;
  roles: string[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateAdministratorRequest {
  username: string;
  senha: string;
  email: string;
  enabled: boolean;
}

export interface UpdateAdministratorRequest {
  username: string;
  senha?: string;
  email: string;
  enabled: boolean;
}

export interface AdministratorsResponse {
  content: Administrator[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

@Injectable({
  providedIn: 'root',
})
export class AdministratorService {
  private apiUrl = `${environment.apiUrl}/admin/administradores`;

  constructor(private http: HttpClient) {}

  /**
   * Get all administrators with pagination and filters
   */
  getAdministrators(filters?: {
    username?: string;
    page?: number;
    size?: number;
  }): Observable<AdministratorsResponse> {
    let params = new HttpParams();

    if (filters?.username) {
      params = params.set('username', filters.username);
    }
    if (filters?.page !== undefined) {
      params = params.set('page', filters.page.toString());
    }
    if (filters?.size !== undefined) {
      params = params.set('size', filters.size.toString());
    }

    return this.http.get<AdministratorsResponse>(this.apiUrl, { params });
  }

  /**
   * Get administrator by ID
   */
  getAdministratorById(id: number): Observable<Administrator> {
    return this.http.get<Administrator>(`${this.apiUrl}/${id}`);
  }

  /**
   * Create new administrator
   */
  createAdministrator(
    data: CreateAdministratorRequest
  ): Observable<Administrator> {
    return this.http.post<Administrator>(this.apiUrl, data);
  }

  /**
   * Update administrator
   */
  updateAdministrator(
    id: number,
    data: UpdateAdministratorRequest
  ): Observable<Administrator> {
    return this.http.put<Administrator>(`${this.apiUrl}/${id}`, data);
  }

  /**
   * Delete administrator
   */
  deleteAdministrator(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
